import Stack from '@mui/material/Stack';
interface IFooterProps {}

//warning
// const Footer = (props: IFooterProps) => <Stack variant='footer' alignItems={'end'}>{`v${process.env.VERSION}`}</Stack>;
const Footer = (props: IFooterProps) => <Stack variant='footer' alignItems={'end'}>{`beta version`}</Stack>;

export default Footer;
